import useEventListener from "./useEventListener";

export default function useWindowEventListener<E extends keyof WindowEventMap>(
  eventName: E,
  handler: EventListener
) {
  return useEventListener(eventName, handler, window);
}
